"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPERIMENTS_SCOPE = 'specs.groups';
exports.TABS_HOOK = 'tabsHook';
exports.GROUP_PAGE = 'group_page';
//# sourceMappingURL=constants.js.map